export default __webpack_public_path__ + "static/service-1-3ceba6a333ef3c38a388cedf41251ab6.jpg";